export * from './decoration-figure.component';
